"use strict";

exports.__esModule = true;
exports.default = void 0;
var _group = _interopRequireDefault(require("./_group.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// Indexes the object's values by a criterion, similar to `_.groupBy`, but for
// when you know that your index values will be unique.
var _default = exports.default = (0, _group.default)(function (result, value, key) {
  result[key] = value;
});